import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const AppTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eef0fb',
      100: '#d3d9f5',
      200: '#a8b3eb',
      300: '#7c8ee0',
      400: '#5168d6',
      500: '#3354c4',
      600: '#2a47a8',
      700: '#213a8c',
      800: '#182d70',
      900: '#0f2054',
      950: '#081440',
    },
  },
});
import {
  AirVent,
  AlertCircle,
  Archive,
  ArrowUp,
  BadgeDollarSign,
  Copy,
  KeyRound,
  ScanSearch,
  Ban,
  BarChart,
  BarChart3,
  Building,
  Building2,
  Calculator,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleCheck,
  Clock,
  DollarSign,
  Download,
  Edit,
  Eye,
  File,
  FilePlus,
  FileText,
  Gavel,
  History,
  House,
  Image,
  Info,
  LoaderCircle,
  LockKeyhole,
  LucideAngularModule,
  // Dashboard specific icons
  MapPin,
  MapPinned,
  Mail,
  Mails,
  Maximize2,
  Music,
  NotepadText,
  Package,
  Pause,
  Pencil,
  Plus,
  Presentation,
  RefreshCw,
  Save,
  Search,
  Sparkles,
  Split,
  Square,
  Star,
  Store,
  Table,
  Trash2,
  Trees,
  TriangleAlert,
  Upload,
  UploadCloud,
  Users,
  Video,
  Wind,
  Wrench,
  X,
} from 'lucide-angular';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    importProvidersFrom(
      LucideAngularModule.pick({
        AirVent,
        BadgeDollarSign,
        NotepadText,
        Split,
        Upload,
        UploadCloud,
        X,
        AlertCircle,
        RefreshCw,
        Square,
        Trash2,
        Eye,
        Info,
        BarChart,
        Download,
        FileText,
        Table,
        Presentation,
        Image,
        Video,
        Music,
        Archive,
        File,
        Gavel,
        Edit,
        Save,
        Plus,
        FilePlus,
        Building,
        DollarSign,
        Calculator,
        Users,
        Calendar,
        LoaderCircle,
        // Dashboard specific icons
        MapPin,
        Package,
        BarChart3,
        Building2,
        Check,
        CircleCheck,
        Clock,
        Ban,
        House,
        MapPinned,
        // PM Services icons
        ChevronDown,
        ChevronLeft,
        ChevronRight,
        Sparkles,
        Wind,
        Trees,
        Search,
        Mail,
        Mails,
        Maximize2,
        LockKeyhole,
        History,
        Pencil,
        Pause,
        Star,
        Store,
        Wrench,
        ArrowUp,
        Copy,
        KeyRound,
        ScanSearch,
        TriangleAlert,
      })
    ),
    MessageService,
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
  ],
};
